//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PropTypes from 'ant-design-vue/es/_util/vue-types';

// 图片选择器组件
export default {
  name: 'SImage',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // 默认显示的图片
    value: PropTypes.string.def(''),
    // 气泡提示内容
    tips: PropTypes.string.def(''),
    // 元素的尺寸(宽)
    width: PropTypes.integer.def(70),
    // 元素的尺寸(高)
    height: PropTypes.integer.def(70)
  },
  data: function data() {
    return {
      // 选择的图片
      imgUrl: ''
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler: function handler(val) {
        this.imgUrl = val;
      }
    }
  },
  created: function created() {},
  methods: {
    // 打开项目内置素材管理弹窗
    handleSelectImage: function handleSelectImage() {
      var _this = this;
      this.$modalUpload(function (img) {
        if (img && img.length > 0) {
          var file = img[0];
          _this.onChange(file);
        }
      }, '1', 'content');
    },
    // 触发change事件
    onChange: function onChange(file) {
      // 记录imgUrl
      this.imgUrl = file.thumbnailPath || file.preview_url || '';
      // v-model
      this.$emit('change', this.imgUrl);
      // 触发update事件
      this.$emit('update', file);
    }
  }
};